<app-loader></app-loader>
<!--
<div class="app-layout">
    <aside class="side-panel left-panel">
    </aside>
    <main class="center-panel">
        <router-outlet (activate)="onRouteActivated($event)"></router-outlet>
    </main>
    <aside class="side-panel right-panel">
    </aside>
</div>
-->
<div *ngIf="appService.screenSize > 0">
    <div class="container">
        <div class="header" style="z-index: 10">
            <div class="shortcuts-pane {{appService.shortcutsPaneDynamicClassName}}">
                <div class="shortcuts">
                    <!--<app-logo></app-logo>-->
                </div>
            </div>
            <div class="navigation-pane {{appService.navigationPaneDynamicClassName}}">
                <div class="navigator">
                    <app-logo></app-logo>
                </div>
            </div>
            <div class="content-pane">
                <!--<div *ngIf="appService.screenSize == 1">
                    <img class="circle-container canton-logo" style="position: absolute;left: 0px;top: 0px;height:46px;width:46px;" src="https://lutzangeles.blob.core.windows.net/app/{{ subdomain }}/{{ subdomain }}.png" />
                </div>-->
                <h2 *ngIf="appService.screenSize != 1" class="banner-text"></h2>
                <div class="breadcrumbs-container {{appService.breadcrumbsDynamicClassName}}">
                    <button *ngIf="appService.screenSize > 1 || appService.isRootNodesCountAboveFooterCapacity" mat-button (click)="appService.toggleNavigation()">
                        <mat-icon class="material-symbols-outlined">
                            menu
                        </mat-icon>
                    </button>
                    <app-breadcrumbs></app-breadcrumbs>
                </div>
                <div class="avatar-container">
                    <app-avatar></app-avatar>
                </div>
            </div>
        </div>
        <div class="body">
            <div class="shortcuts-pane {{appService.shortcutsPaneDynamicClassName}}">
                <div class="shortcuts">
                    <app-shortcuts></app-shortcuts>
                </div>
            </div>
            <div class="navigation-pane {{appService.navigationPaneDynamicClassName}}">
                <div class="navigator">
                    <app-navigator></app-navigator>
                </div>
            </div>
            <div class="content-pane" style="border: 0px solid blue;width:50%;"> <!-- trick to stop content from squeezing side panels such as the left navigator -->
                <router-outlet (activate)="onRouteActivated($event)"></router-outlet>
                <div style="width: 100%;position: sticky;bottom: 48px;z-index: 1000;background-color: var(--color-background-primary);">
                    <mat-form-field class="{{ appService.appFeedMatFormFieldContainerDynamicClassName }}" appearance="outline" style="width: 100%;">
                        <input matInput value="placeholderInput" style="display: none;" />
                        <mat-label>App Feed</mat-label>
                        <div class="appfeed-pane {{ appService.appFeedPaneDynamicClassName }}">
                            <button mat-button *ngIf="false" (click)="appService.toggleappFeedPane()" style="float: right;position: sticky;top: 12px;right: 0px;">
                                <mat-icon class="material-symbols-outlined">
                                    close
                                </mat-icon>
                            </button>
                            <app-app-feed [dataSource]="this.appService.appFeedMessages"></app-app-feed>
                        </div>
                    </mat-form-field>
                    <div class="actions-bar-container">
                        <app-actions></app-actions>
                    </div>
                </div>
                <div *ngIf="!appService.isRootNodesCountAboveFooterCapacity" class="mobile-navigator" class="{{ appService.mobilenavigatorPaneDynamicClassName }}">
                    <app-navigator></app-navigator>
                </div>
            </div>
            <div *ngIf="appService.isShareConsoleAvailable" class="share-console {{appService.shareConsoleDynamicClassName}}">
                <div class="help">
                    <app-help></app-help>
                </div>
            </div>
        </div>
        <div *ngIf="appService.screenSize != 1" class="footer">
            <div style="padding-top:14px;">
                <div *ngIf="!isDiagnosticsOn">&copy;&nbsp;&nbsp;2026 Lutz Angeles Inc. All Rights Reserved</div><div *ngIf="isDiagnosticsOn">{{ dims }}</div>
            </div>
        </div>
    </div>
</div>
